import { render, staticRenderFns } from "./FileBox.vue?vue&type=template&id=b541b32e"
import script from "./FileBox.vue?vue&type=script&lang=js"
export * from "./FileBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports